export default __webpack_public_path__ + "73e9062161a3ea5984526c5a8317da5c.png";